export interface IListOption {
    label: string,
    value: string;
}

export interface IVehicleBase {
    id: number,
    year: number,
    make: string,
    model: string,
    vin: string,
    garagingAddress: IAddress | null;
}

export interface IVehicle extends IVehicleBase {
    body: string,
    engineSize: string,
    cylinders: number,
    specs: string,
    ownership: string,
    payments: string,
    useYears: string,
    antiTheftOnStar: boolean,
    antiTheftVehicleRecoveryDevice: boolean,
    antiTheftAutomaticDisabling: boolean,
    vehicleUse: string,
    valueMiles: string,
    mileage: string,
    parkAtHome: string,
    lienholder: string,
    licenseNumber: string,
    antithft: string;
}

export const emptyVehicle = {
    id: 0,
    year: 0,
    make: "",
    model: "",
    body: "",
    engineSize: "",
    cylinders: 0,
    specs: "",
    vin: "",
    ownership: "",
    payments: "",
    useYears: "",
    antiTheftOnStar: false,
    antiTheftVehicleRecoveryDevice: false,
    antiTheftAutomaticDisabling: false,
    vehicleUse: "",
    valueMiles: "",
    mileage: "",
    lienholder: "",
    licenseNumber: "",
    parkAtHome: "",
    garagingAddress: null,
    antithft: ""
};

export const emptyAddress = {
    street: "",
    city: "",
    apartment: "",
    stateCode: "",
    zipCode: ""
}

export interface IUSPSResult {
    street1: string,
    street2: string,
    city: string,
    state: string,
    zip: string;
}

export interface IAddress {
    street: string,
    city: string,
    apartment: string,
    stateCode: string,
    zipCode : string;
}

export interface IAddressChangeResult {
    address: IAddress,
    isFull: boolean,
    isValid?: boolean;
}

export interface IIncidentInfo {
    id : number,
    type: string,
    month: number | null,
    year: number | null,
    description: string;
}

export interface IPerson {
    id: number,
    firstName: string,
    lastName: string,
    birthDate: string,
    gender: string,
    address: IAddress | null;
}

export interface IDriverBase extends IPerson {
    licenseNumber: string,
    licenseState: string,
    isInsured: boolean,
    fromClue: boolean,
    incidents: Array<IIncidentInfo>;
}

export interface IDriver extends IDriverBase {
    maritalStatus: string,
    education: string,
    employment: string,
    occupation: IDictionaryItem | null,
    militaryBranch: string,
    militaryRank: string,
    hasBAverageOrHigher: string;
}

export interface ICurrentInsurance {
    id: number,
    hasInsurance: string,
    currentInsuranceDetails: string,
    beenUninsured: string,
    uninsuredPeriod: string,
    currentInsuranceCompany: "",
    currentInsuranceCompanyPeriod: "",
    currentInsuranceCompanyMonths: "",
    currentBiLimits: "",
    currentPolicyExpirationDate: Date | null,
    effectiveDate: string,
    otherEffectiveDate: Date | null,
    effectiveDateOption: string,
    otherEffectiveDateOptionVisible: boolean,
    otherEffectiveDateOptionSelected: boolean,
    receiveDocumentsElectronically: string;
}

export interface IContactInfo {
    id: number,
    email: string,
    phone: string,
    emailSubscription: boolean,
    phoneMessagesSubscription: boolean;
}

export interface IDictionaryItem {
    id: string,
    name: string;
}

export interface ICoverage {
    name: string,
    code: string,
    limit: string,
    value: string,
    order: number,
    isSelected: boolean,
    canBeDeclined: boolean,
    isDeclined:boolean;
}

export interface IVehicleCoverages {
    vehicleId: number,
    vehicleDescription: string,
    coverages: Array<ICoverage>;
}

export interface ICoverageConfig {
    name: string,
    code: string,
    liabilityCoverages : Array<ICoverage>,
    vehicleCoverages: Array<IVehicleCoverages>
}

export interface IOfferErrors {
    code : string,
    domain : string,
    domainKey : string,
    text : string
}

export interface IRate {
    rate: IRealTimeAutoResult,
    paymentChoices: Array<IPaymentChoice>,
    isError: boolean,
    agenciesContactInfo: IAgenciesContactInfo,
    offerErrors: Array<IOfferErrors>;
}

export interface IPaymentChoice {
    urlMemo: string,
    payTerm: string,
    payPlanDesc: string,
    payCount: number,
    firstPay: number,
    regularPay: number,
    iFee: number,
    payTotal: number;
    selected: boolean;
}

export interface IAgenciesContactInfo {
    callCenterPhone: string,
    agencyContacts: Array<IAgencyContacts>
}

export interface IAgencyContacts {
    agencyName: string,
    agencyPhone: string,
    agencyStreetAddress: string,
    producerCode: string,
    storeNumber: string,
    agencyWebsiteURL: string;
}

export interface IRealTimeAutoResult {
    messageMemo: string,
    urlMemo: string,
    urlLogo: string,
    vehicleRates: Array<IVehicleResult>,
    isError: boolean
}

export interface IVehicleResult {
    year: string,
    make: string,
    model: string,
    total: string,
    liabilityCoverages: Array<ICoverageResult>,
    vehicleCoverages: Array<ICoverageResult>,
    fees: Array<ICoverageResult>
}

export interface ICoverageResult {
    code: string,
    title: string,
    limit: string,
    amt: string,
}

export interface IPaymentInfo {
    savePaymentMethod: boolean,
    billingAddress: IAddress | null;
}

export interface ICreditCardInfo extends IPaymentInfo {
    cardHolderFirstName: string,
    cardHolderLastName: string,
    cardExpirationFull: string,
    cardExpirationMonth: number,
    cardExpirationYear: number,
    cardNumber: string;
}

export interface IAdditionalDriver {
    driver: IDriverBase,
    status: string
}

export interface IDriverOption {
    value: string,
    label: string
}